import { render } from "./SwiperSlider.vue?vue&type=template&id=64eb6d70&scoped=true"
import script from "./SwiperSlider.vue?vue&type=script&lang=js"
export * from "./SwiperSlider.vue?vue&type=script&lang=js"

import "./SwiperSlider.vue?vue&type=style&index=0&id=64eb6d70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64eb6d70"]])

export default __exports__